import React from "react";

import { IoTimeSharp } from "react-icons/io5";
const SelectableBlockRoom = ({
                             title,
                             titleAdditional,
                             setTimer,
                             setTypeTimer,
                             onSelect,
                             isSelected,
                             classname="selectable-block-room" ,}) => {
    return (
        <div
            className={`${classname} ${isSelected ? "selected" : ""}`}
            onClick={() => onSelect(title)}
        >
            <div className="time-icon">
                <IoTimeSharp/>
                <p>{setTimer}{setTypeTimer}</p>
            </div>

            <h1>{title}</h1>
            <h2>{titleAdditional}</h2>
        </div>
    );
};

export default SelectableBlockRoom;